import { gql } from "@apollo/client";

const GET_STAGES = gql`
  query GetStages {
    stages {
      count
      items {
        id
        parentId
        stageName
        stageKey
        styles {
          color
          bg
          border
        }
        queryConfig {
          sortConfig
          groupConfig {
            limit
            groupBy
          }
          displayOrder
          columnAliasKey
        }
      }
    }
  }
`;

export default GET_STAGES;
